import gsap from 'gsap'
import drawOutline from '@/mixins/lib/drawOutline'
import getDelta from '@/mixins/lib/getDelta'

export const drawify = {
    data: () => ({
        drawed  : false,
        points  : {},
        path    : ''
    }),
    methods: {
        collectPoints(data) {
            this.points[data.id] = this.points[data.id] || []
            this.points[data.id].push(data.el)
        },
        drawCircle(){
            if ( !this.hasDiscoverPath || this.drawed || this.notLast ) 
                return; else {
                this.drawed = true
            }
            
            this.path = drawOutline( this.points, this.currentSlide )
        }
    },
    computed: {
        notLast() {
            return this.currentSlide !== this.i - 1
        },
    },
    watch: {
        active: {
            // immediate: true,
            handler( value ) {
                ( !this.notLast && value ) 
                && setTimeout(this.drawCircle, 500)
        }},
    },
}

export const wavify = {
    data() {
        return {
            circlesVisible : false,
        }
    },
    beforeDestroy() {
        this.$off('slide-waves-toggle')
    },
    mounted() {
        this.$on('slide-waves-toggle', x => {
            this.circlesVisible = x
        })
    },
}

export const fillify = {
    data() {
        return {
            pathStage: 0,
            pathProgress: 1,
            pathWidth: 1920,
        }
    },
    computed: {
        pathOffset() {
            return this.pathWidth * this.pathProgress
        },
    },
    methods: {
        setPathTotal() {
            const svg = this.$refs['svg-recruit']
            if ( !svg || !svg.$el ) return;

            const path = svg.$el.querySelector('.path--fill')
            const pathLen = path.getTotalLength()

            this.pathWidth = pathLen
        },
        getProgress( progress ) {
            const { getters } = this.$store
            const isPortrait = getters['browser/isTabletPortrait']

            switch (progress) {
                case 0: 
                    return isPortrait ? .9 : .935;
                case 1: 
                    return isPortrait ? .75 : .8077;
                case 2: 
                    return isPortrait ? .47 : .6735;
                case 3: 
                    return isPortrait ? .62 : .545;
                case 4: 
                    return isPortrait ? .28 : .34;
                case 5: 
                    return isPortrait ? .14 : .135;
                case 6: 
                    return 0; 
                default:
                    return this.pathWidth
            }
        },
        animateProgress(pathProgress, stage = 1) {
            const duration = getDelta(stage, this.pathStage)
            
            this.pathStage = stage

            return gsap.to(this.$data, { 
                duration, 
                pathProgress,
            })
        },
        getPathProgressed(stage) {
            const progressed = this.getProgress(stage)

            return [progressed, stage]
        },
        afterProgress(onComplete) {
            this.$root.$emit('slides-lock-scroll', false)
            
            return typeof onComplete === 'function' && onComplete()
        },
        setupPath() {
            this.setPathTotal()
        },
    },
    deactivated() {
        this.$root.$off('slide-recruit-progress')
    },
    activated() {
        this.$nextTick(() => {
            this.setupPath()
        })

        this.$root.$on('slide-recruit-progress', ({ stage = 6, fromNav = false, onComplete = null }) => {
            if (this.active.length < 1) {
                return;
            }

            this.$root.$emit('slides-lock-scroll', true)
            const progressed = this.getProgress(stage)

            if (progressed === this.pathProgress || (fromNav && this.pathStage < 5)) {
                return this.afterProgress(onComplete)
            }

            return this
                .animateProgress(progressed, stage)
                .then(() => this.afterProgress(onComplete))
            
        })
    },
}